module.exports = __webpack_public_path__ + "static/media/aci.5b44a091.png";